import SimpleStringAttribute from './SimpleStringAttribute';

export default class SimpleContainerBarChartPropAttribute extends SimpleStringAttribute {
    exportTo(context, styleSet) {
        const { xStyle } = styleSet;
        if (!xStyle.container) {
            xStyle.container = {};
            xStyle.container.borderStyle = 'solid';
        }

        const style = styleSet.xStyle.container;
        if (typeof this.value === 'string' && SimpleStringAttribute.hasConstantRef(this.value)) {
            SimpleStringAttribute.exportConstantAsRef(style, this.overrideName, this.value);
        } else {
            style[this.overrideName] = this.value;
        }
    }
}
